import { Tooltip } from 'ui/tooltip';
import { Refresh16, ChevronDown16 } from 'ui/icons/aurora';
import { PrimaryButton, IconButton, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { ActionMenu } from 'ui/actionMenu';
import { FlexSpacer } from 'ui/flexSpacer';
import { AllowedActionMenuElements } from 'ui/actionMenu/types';
import { MISSING_MANAGE_CATALOGS_PERMISSION } from 'modules/catalog/catalogConstants';
import { TableViewSettingsToggle } from 'modules/catalog/tableViewSettingsToggle';
import { UPDATE_CATALOG_ITEM_METHOD } from '../constants';

type CatalogTableToolbarContentProps = {
  isDisplayTable: boolean;
  canManageCatalogs: boolean;
  handleChangeUpdateMethodCatalogItems: (value: string) => void;
  handleRefreshTable: () => void;
  handleJsonOrTableOnClick: () => void;
};

export const CatalogTableToolbarContent = ({
  canManageCatalogs,
  handleChangeUpdateMethodCatalogItems,
  handleJsonOrTableOnClick,
  handleRefreshTable,
  isDisplayTable,
}: CatalogTableToolbarContentProps) => {
  return (
    <FlexSpacer justifyContent="space-between">
      <FlexSpacer>
        <ActionMenu
          options={[
            {
              as: AllowedActionMenuElements.Button,
              content: 'Add using JSON',
              id: UPDATE_CATALOG_ITEM_METHOD.JSON,
              onClick: () => handleChangeUpdateMethodCatalogItems(UPDATE_CATALOG_ITEM_METHOD.JSON),
            },
            {
              as: AllowedActionMenuElements.Button,
              content: 'Bulk update with CSV',
              id: UPDATE_CATALOG_ITEM_METHOD.CSV,
              onClick: () => handleChangeUpdateMethodCatalogItems(UPDATE_CATALOG_ITEM_METHOD.CSV),
            },
          ]}
        >
          <Tooltip
            isEnabled={!canManageCatalogs}
            tooltipContent={MISSING_MANAGE_CATALOGS_PERMISSION}
          >
            <PrimaryButton
              data-test="catalog-table-update-catalog-items-button"
              size={BUTTON_SIZES.SMALL}
              isDisabled={!canManageCatalogs}
            >
              Update catalog items <ChevronDown16 />
            </PrimaryButton>
          </Tooltip>
        </ActionMenu>
        <IconButton
          data-test="catalog-table-refresh-button"
          onClick={handleRefreshTable}
          size={BUTTON_SIZES.SMALL}
          variant={BUTTON_VARIANTS.SECONDARY}
        >
          <Refresh16 />
        </IconButton>
      </FlexSpacer>
      <TableViewSettingsToggle onChange={handleJsonOrTableOnClick} isTableView={isDisplayTable} />
    </FlexSpacer>
  );
};
